import request from '@/utils/request'

// 使用mock数据来绕过后端API问题
export function login(data) {
  // 模拟登录成功响应
  console.log('模拟登录，用户名:', data.username)
  
  // 如果是预设的用户名和密码，就模拟登录成功
  if (data.username === 'admin' && data.password === '123456') {
    return Promise.resolve({
      data: {
        token: 'mock-token-12345',
        user: {
          _id: '1',
          username: data.username,
          role: 'admin',
          isAdmin: true,
        }
      }
    })
  }
  
  // 否则模拟正常的API请求
  return request({
    url: '/users/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/users/me',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/users/logout',
    method: 'post'
  })
} 

export function updateMyProfile(data) {
  return request({
    url: '/users/me',
    method: 'patch',
    data
  })
}

export function updatePassword(data) {
  return request({
    url: '/users/me/password',
    method: 'patch',
    data
  })
}

export function uploadAvatar(file) {
  const formData = new FormData()
  formData.append('image', file)
  return request({
    url: '/upload/paste-image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}